import { LbaItemTag } from "@/components/SearchForTrainingsAndJobs/components/LbaItemTag"

export const TagRecrutementUrgent = () => {
  return (
    <LbaItemTag color="red" iconClassName="fr-icon-fire-fill">
      RECRUTEMENT URGENT
    </LbaItemTag>
  )
}
